let langSelectContainer = document.querySelector(".lang-select-container");
let langSelectOverflow = document.querySelector(".lang-select-overlay");
let langSelectCloseBtn = document.getElementById("lang_swatch_close");
let langSelector = document.getElementById("lang_selector");

langSelector.addEventListener("click", function(){
    langSelectContainer.classList.remove("hide");
    document.body.classList.add("scroll_lock");
});

langSelectOverflow.addEventListener("click", function(){
    langSelectContainer.classList.add("hide");
    document.body.classList.remove("scroll_lock");
});

langSelectCloseBtn.addEventListener("click", function(){
    langSelectContainer.classList.add("hide");
    document.body.classList.remove("scroll_lock");
});